import React, { Component } from 'react'
import { Link, useHistory } from 'react-router-dom';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { ThemeProvider } from 'styled-components';

class Grupo extends Component {

    constructor(props){
        super(props);

        this.state = {
            items: [],
            itensRow:[],
            isListagem:true,
            isEdicao: false,
            id:'',
            nome:'',
            permissao:''
            
        }

        this.add = this.add.bind(this);
        this.edit = this.edit.bind(this);
        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
        this.cancel = this.cancel.bind(this);
        this.atualiza = this.atualiza.bind(this);
        this.permissao = this.permissao.bind(this);
        this.adicionarPermissao = this.adicionarPermissao.bind(this);
    }

    async componentDidMount() {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo');       
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 21 })
        if( empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('VER') < 0 ) return this.props.history.push('/index') 
        
        
        await api.get('/api/grupo', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState( { items : response.data } );
        })
    }

    add = async(item) => {

        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 21  })
        if( empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 
        
        this.setState({
            isListagem: false, 
            isEdicao:true,
            id:'',
            nome:'',           
        })

    }

    edit = async( id ) => {
        
        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 21  })
        if( empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
        
        
        try {
       
        
       
            await api.get(`/api/grupo/${id}`, {
                headers: {
                    'x-access-token':token,
                }
            }).then(response => {
                this.setState({
                    isListagem: false, 
                    isEdicao:true,
                    id:response.data.id,
                    nome:response.data.nome,                   
                })      
            });

        } catch (error) {
            this.alert(error)       
        }
    }

    cancel = (item) => {
        const token    = sessionStorage.getItem('token');
       
        api.get('/api/grupo', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                id:'',
                nome:'',
                items : response.data    
            })
        })     

    }

    save = async (event) => {
        event.preventDefault();
        const { id,  nome, tipo } = this.state
        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 21  })
        //if( id && empresaGrupo[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
        //if( !id && empresaGrupo[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 
        
        
        try {
            
            if ( id ) {
                if(  empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
                await api.put(`/api/grupo/${id}`,{ nome }, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
                    api.get('/api/grupo', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {           
                        toast.success("Registro salvo.");                        
                        this.setState({
                            isListagem: true, 
                            isEdicao:false,
                            id:'',
                            nome:'',                          
                            items : response.data
                
                        });
                       
                    })
                })
            } else {
                if(  empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 
                await api.post('/api/grupo',{ id, nome, tipo }, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then( async response => {
                    const grupo = response.data.id
                    await api.get('/api/menu', {
            
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(async response => {

                        response.data.forEach(async element => {
                            
                            await api.post('/api/permissao', { grupo:grupo, menu:element.id },{
                                headers: {
                                    'x-access-token':token,
                                }
                            })
                        });

                    }).then(async response => {
                        await api.get('/api/grupo', {
                            headers: {
                                'x-access-token':token,
                            }
                        }).then(response => {           
                            toast.success("Registro salvo.");                        
                            
                            this.setState({
                                isListagem: true, 
                                isEdicao:false,
                                id:'',
                                nome:'',
                                items : response.data
                    
                            });
                        })
                    })
                })
            }
        } catch (error) {
            toast.error(error)            
        }
        
    }

    delete = async (id) => {

        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 21  })
        if( empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('EXCLUIR') < 0 ) return toast.error('O usuário sem permissão.') 
        
        
        try {
            
            if ( window.confirm(`Confirma deleção do registro ${id}?`)) {
            
                await api.delete(`/api/grupo/${id}`, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
                    api.get('/api/grupo', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {
                        this.setState( { items : response.data } );
                        toast.error(<i class="fas fa-trash-alt nav-icon"> Registro Excluído Com Sucesso!</i>)
                    });
                });
            }
        } catch (error) {
            toast.error("Ocorreu um erro ao tentar excluisr o registro.")       
        }
    }

    permissao = async(id) =>{

           
        const token    = sessionStorage.getItem('token');
        
        
        
        try {
       
            await api.get(`/api/permissao/${id}`, {
                headers: {
                    'x-access-token':token,
                }
            }).then(response => {
                this.setState({
                    permissao: response.data            
                })      
            });
            
        } catch (error) {
            
        }
    }
    
    adicionarPermissao = async( grupo, menu, permissao, acesso ) => {
        const grupoUsuario     = sessionStorage.getItem('grupo');    
        const token    = sessionStorage.getItem('token');
        const permissoes = await api.get(`/api/permissao/${grupoUsuario}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 21   })
        if( empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('PERMISSAO') < 0 ) return toast.error('O usuário sem permissão.') 

        try {
       
            const permissoes = await api.get(`/api/permissao/${grupo}`, {
                headers: {
                    'x-access-token':token,
                }
            })
           
            const filtroPermissao = permissoes.data.filter( item => item.idgrupo == grupo && item.idmenu == menu );
            let minhasPermissoes = filtroPermissao[0].permissao
           
            if( minhasPermissoes ) {
            
                if ( minhasPermissoes.indexOf(acesso) >= 0 ) {
                    minhasPermissoes = minhasPermissoes.replace( acesso + ';','');
                } else {
                    minhasPermissoes = minhasPermissoes +  acesso +';'
                }
            } else {
                minhasPermissoes = acesso + ';'
            }
        
            await api.put(`/api/permissao/${filtroPermissao[0].id}`, {grupo, menu,permissao: minhasPermissoes }, {
                headers: {
                    'x-access-token':token,
                }
            }).then(async response => {
            
                await api.get(`/api/permissao/${grupo}`, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
                    this.setState({
                        permissao: response.data            
                    })      
                });
            })             
             
        } catch (error) {
            toast.error('Ops!Ocorreu um erro ao tentar gravar a permissão'+ error)
        }

    }

    atualiza = async() => {

        const token    = sessionStorage.getItem('token');
       
        await api.get('/api/grupo', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                id:'',
                nome:'',               
                items : response.data    
            })
        })
    }
    
    render() {

        const columns = [
            {
              name: 'Id',
              selector: 'id',
              sortable: true,
            },
            {
              name: 'Nome',
              selector: 'nome',
              sortable: true,
            }, 
            {
                name: ' ',
                selector: 'permissao',
                cell: row =>    <div class="btn-group">
                                    <Link onClick={ () => this.permissao( row.id ) } class="btn btn-warning" data-toggle="modal" data-target="#modal-lg">Permissão</Link>
                                </div>,
            },       
            {
                name: 'Editar',
                selector: 'Editar',
                cell: row =>   <div class="btn-group">
                                  <button id="editar" className="btn btn-default" onClick={ () => { this.edit(row.id)}}><i class="fa fa-edit"></i></button>
                                  <button id="excluir" className="btn btn-danger" onClick={ () => { this.delete(row.id)}}><i class="fas fa-trash-alt"></i></button>                                                           
                              </div>,
                button: true,
            }
        ];
        const {items,isListagem, isEdicao} = this.state;
    
        return ( 
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                           
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title"><i className="fas fa-address-book"></i> CADASTRO GRUPO</h3>

                                <div className="card-tools">
                                    <button type="button" className="btn btn-tool" data-card-widget="Atualizar" data-toggle="Atualizar" title="Atualizar" onClick={ () => this.atualiza() }>
                                        <i className="fas fa-sync"></i>
                                    </button>
                                
                                    <button type="button" className="btn btn-tool" data-card-widget="Minimizar" data-toggle="Minimizar" title="Minimizar">
                                        <i className="fas fa-minus"></i>
                                    </button>
                                
                                </div>
                            </div>
                            <div className="card-body">
                        
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" id="custom-tabs-two-tab" role="tablist">
                                            <li className="nav-item">
                                                <a className={ isListagem ? "nav-link active" : "nav-link" } id="custom-tabs-listagem-dados-tab" data-toggle="pill" onClick={ () => this.cancel } href="#custom-tabs-listagem-dados" role="tab" aria-controls="custom-tabs-listagem-dados" aria-selected={ isListagem ? true : false }>Listagem</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={ isEdicao   ? 'nav-link active' : 'nav-link' } id="custom-tabs-edicao-dados-tab" data-toggle="pill" onClick={() => this.add } href="#custom-tabs-edicao-dados" role="tab" aria-controls="custom-tabs-edicao-dados" aria-selected={isEdicao ? true : false }>Edição</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content" id="custom-tabs-two-tabContent">
                                            <div className={ isListagem ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-listagem-dados" role="tabpanel" aria-labelledby="custom-tabs-listagem-dados-tab">
                                                <DataTable
                                                    title="Listar"
                                                    columns={columns}
                                                    data={items}
                                                    pagination
                                                />
                                                <button type="button" onClick={ this.add } className="btn btn-info pull-right">Novo</button>
                                                <div class="modal fade" id="modal-lg">
                                                    <div class="modal-dialog modal-lg">
                                                        <div class="modal-content">
                                                            <div class="modal-header">
                                                                <h4 class="modal-title">Definição de Permissões</h4>
                                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                            </div>
                                                            <div class="modal-body">
                                                                { this.state.permissao.length > 0  ?
                                                                    <DataTable
                                                                        title="Permissões"
                                                                        columns={[                                                                            
                                                                                    {
                                                                                        name: 'Menu',
                                                                                        selector: 'menu',
                                                                                        sortable: true,
                                                                                    },
                                                                                    {
                                                                                        name: 'Ver',
                                                                                        selector: 'ver',
                                                                                        sortable: true,
                                                                                        cell: row => row.acessos.indexOf('VER') >= 0 ?  <div class="form-group">
                                                                                                        <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                                                                                            <input type="checkbox" class="custom-control-input" id={ row.menu + 'VER'} checked={row.permissao && row.permissao.indexOf('VER') >= 0 ? true : false } onClick={ () => this.adicionarPermissao(row.idgrupo, row.idmenu,( row.permissao && row.permissao.indexOf('VER') >= 0 ? true : false  ), 'VER' ) } />
                                                                                                            <label class="custom-control-label" for={ row.menu + 'VER' }></label>
                                                                                                        </div> 
                                                                                                    </div> : ''
                                                                                    },
                                                                                    {
                                                                                        name: 'Inserir',
                                                                                        selector: 'incluir',
                                                                                        sortable: true,
                                                                                        cell: row => row.acessos.indexOf('INSERIR') >= 0 ?  <div class="form-group">
                                                                                                        <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                                                                                            <input type="checkbox" class="custom-control-input" id={ row.menu + 'INSERIR' } checked={row.permissao && row.permissao.indexOf('INSERIR') >= 0 ? true : false } onClick={() => this.adicionarPermissao(row.idgrupo, row.idmenu, ( row.permissao && row.permissao.indexOf('INSERIR') >= 0 ? true : false), 'INSERIR' ) } />
                                                                                                            <label class="custom-control-label" for={ row.menu + 'INSERIR' }></label>
                                                                                                        </div> 
                                                                                                    </div> : ''
                                                                                    },
                                                                                    {
                                                                                        name: 'Editar',
                                                                                        selector: 'editar',
                                                                                        sortable: true,
                                                                                        cell: row => row.acessos.indexOf('ALTERAR') >= 0 ?  <div class="form-group">
                                                                                                        <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                                                                                            <input type="checkbox" class="custom-control-input" id={ row.menu + 'ALTERAR'} checked={row.permissao && row.permissao.indexOf('ALTERAR') >= 0 ? true : false } onClick={() => this.adicionarPermissao(row.idgrupo, row.idmenu, ( row.permissao && row.permissao.indexOf('ALTERAR') >= 0 ? true : false ), 'ALTERAR' ) } />
                                                                                                            <label class="custom-control-label" for={ row.menu + 'ALTERAR' }></label>
                                                                                                        </div> 
                                                                                                    </div> : ''
                                                                                    },
                                                                                    {
                                                                                        name: 'Deletar',
                                                                                        selector: 'excluir',
                                                                                        sortable: true,
                                                                                        cell: row => row.acessos.indexOf('EXCLUIR') >= 0 ?  <div class="form-group">
                                                                                                                                                <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                                                                                                                                    <input type="checkbox" class="custom-control-input" id={ row.menu + 'EXCLUIR' } checked={row.permissao && row.permissao.indexOf('EXCLUIR') >= 0 ? true : false } onClick={() => this.adicionarPermissao(row.idgrupo, row.idmenu,( row.permissao && row.permissao.indexOf('EXCLUIR') >= 0 ? true : false), 'EXCLUIR' ) } />
                                                                                                                                                    <label class="custom-control-label" for={ row.menu  + 'EXCLUIR'}></label>
                                                                                                                                                </div> 
                                                                                                                                            </div> : ''
                                                                                    },
                                                                                    {
                                                                                        name: 'Laudar',
                                                                                        selector: 'laudo',
                                                                                        sortable: true,
                                                                                        cell: row => row.acessos.indexOf('LAUDAR') >= 0 ?  <div class="form-group">
                                                                                                                                                <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                                                                                                                                    <input type="checkbox" class="custom-control-input" id={ row.menu + 'LAUDAR' } checked={row.permissao && row.permissao.indexOf('LAUDAR') >= 0 ? true : false } onClick={() => this.adicionarPermissao(row.idgrupo, row.idmenu,( row.permissao && row.permissao.indexOf('LAUDAR') >= 0 ? true : false), 'LAUDAR' ) } />
                                                                                                                                                    <label class="custom-control-label" for={ row.menu  + 'LAUDAR'}></label>
                                                                                                                                                </div> 
                                                                                                                                            </div> : ''
                                                                                    },
                                                                                    {
                                                                                        name: 'Permissão',
                                                                                        selector: 'permissao',
                                                                                        sortable: true,
                                                                                        cell: row => row.acessos.indexOf('PERMISSAO') >= 0 ?  <div class="form-group">
                                                                                                                                                <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                                                                                                                                    <input type="checkbox" class="custom-control-input" id={ row.menu + 'PERMISSAO' } checked={row.permissao && row.permissao.indexOf('PERMISSAO') >= 0 ? true : false } onClick={() => this.adicionarPermissao(row.idgrupo, row.idmenu,( row.permissao && row.permissao.indexOf('PERMISSAO') >= 0 ? true : false), 'PERMISSAO' ) } />
                                                                                                                                                    <label class="custom-control-label" for={ row.menu  + 'PERMISSAO'}></label>
                                                                                                                                                </div> 
                                                                                                                                            </div> : ''
                                                                                    }
                                                                                ]

                                                                        }
                                                                        data={this.state.permissao}
                                                                        pagination={false}
                                                                    />
                                                                    :
                                                                    "Sem Permissão para definir acessos."
                                                                }
                                                                
                                                            </div>
                                                            <div class="modal-footer justify-content-between">
                                                                <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
                                                                
                                                            </div>
                                                        </div>         
                                                    </div>        
                                                </div>
                                            </div>
                                            <div className={ isEdicao ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-edicao-dados" role="tabpanel" aria-labelledby="custom-tabs-edicao-dados-tab">
                                                <form onSubmit={ this.save }>
                                                    <div className="form-group">
                                                        <label>ID</label>
                                                        <input type="text" className="form-control" name="id" placeholder="ID do Registro" value={ this.state.id } onChange={ e => this.setState({ id: e.target.value})} readOnly/>
                                                    </div>
                                                    
                                                    <div className="form-group">
                                                        <label>Nome</label>
                                                        <input type="text" className="form-control" name="nome" placeholder="Nome do Registro" value={ this.state.nome } onChange={ e => this.setState({ nome: e.target.value})} required/>
                                                    </div>
                                                    
                                                    <button type="submit" className="btn btn-success pull-right">Salvar</button>
                                                    <button type="button" className="btn btn-danger pull-right" onClick={ this.cancel }>Cancelar</button>
                                                </form>
                                            </div>                                        
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div className="card-footer">                        
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        )
    }
        
}

export default Grupo;